export default __webpack_public_path__ + "static/media/minecraft.c3ecdd3b.png";